import React from "react";
import { useWindowSize } from 'react-use';
import Confetti from 'react-confetti';
import { Container, Grid, Paper, Typography, Button } from '@mui/material';
import globals from "../globals";

const SuccessfulForm = () => {
    const { width, height } = useWindowSize();

    return (
        <Container sx={{mt:5}}>
            <Grid container justifyContent={'center'} textAlign={'center'} direction={'column'} alignContent={'center'} spacing={4}>
                <Grid item>
                    <a href='/'><img src='eacademiabg-logo.png' width={200} height={90}/></a>
                </Grid>
                <Confetti width={width} height={height}/>
                <Grid item>
                    <Paper elevation={4} sx={{ width: '80vh', borderRadius: 5 }}>
                        <Grid container justifyContent={'center'} textAlign={'center'} direction={'column'}>
                            <Grid item>
                                <img src="success.png" width={250} height={250} />
                            </Grid>
                            <Grid item>
                                {/* <Typography sx={{ color: globals.colors.lightRed, fontSize: 30, fontWeight: 'bold' }}>{props.location.state.title}</Typography> */}
                                <Typography sx={{ color: globals.colors.lightRed, fontSize: 30, fontWeight: 'bold' }}>Успешно изпратена форма!</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 15, fontWeight: 'bold' }}>Благодарим ти, че избра да станеш учител в eAcademiaBg!</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 15, fontWeight: 'bold' }}>Ще се свържем с теб по имейл за повече информация.</Typography>
                            </Grid>
                            <Grid item>
                                <Button variant='contained' href='/register' type='submit' size='large' sx={{
                                    mt: 3, mb:3, px: 5, backgroundColor: globals.colors.lightRed, '&:hover': {
                                        backgroundColor: globals.colors.darkRed,
                                    }, textTransform:'none', fontWeight:'bold'
                                }}> Към регистрация</Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
}

export default SuccessfulForm